
export const audios = [
    { title: "Song  1", artist: "Artist  1", src: "https://audio.jukehost.co.uk/a8rfTAi9QOTANudw2k1IzzXlnGZjgohM", imgurl:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTY-lM3ktguFHXGQ1NsoIgFeT8_qVQPT6yw9aiv3JXyvQ&s" },
    { title: "Song  2", artist: "Artist  2", src: "https://audio.jukehost.co.uk/a8rfTAi9QOTANudw2k1IzzXlnGZjgohM", imgurl:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTY-lM3ktguFHXGQ1NsoIgFeT8_qVQPT6yw9aiv3JXyvQ&s" },
    // ... more songs
  ];
  